import { HttpHeaders, HttpParams } from "@angular/common/http";
import { Router } from '@angular/router';
import { Component, OnInit, TemplateRef, ViewChild, ElementRef } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from '@angular/router';
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { ServiciosService } from "src/app/core/services/servicios.service";
import { IntegracionServices } from "src/app/core/services/integraciones.service";
import { FileUploadComponent } from 'src/app/shared/components/file-upload/file-upload.component';
import { ServicioModel } from "src/app/models/Servicio.model";
import { lastValueFrom, takeUntil, Subject } from "rxjs";
import Swal, { SweetAlertIcon } from 'sweetalert2';

import { TableAction } from "src/app/shared/components/table-paginator/table-paginator.component";
import { k } from "src/environments/properties";
import { PermisosModalComponent } from "src/app/shared/components/permisos-acceso/permisos-modal.component";
import { AuthService } from "src/app/core/services/AuthService";



interface Item {
    id: string,
    nombre?: string;
    nombre_corto?: string;
    width?: string;
    height?: string;
    createdAt?: string,
    updatedAt?: string,
    deletedAt?: string,
    publica?: boolean,
}

@Component({
    selector: 'app-documentos-por-firmar',
    templateUrl: './servicios-externos.component.html',
    styleUrls: ['./servicios-externos.component.scss']
})
export class ServiciosExternosComponent implements OnInit {

    selectedFiles: File | File[] | FileList | null = null;
    currentItems: ServicioModel[] = []; // Los datos para la página actual
    private destroy$ = new Subject<void>();

    lotesPorFirmar: any[] = [];
    totalItemsLotesPorFirmar: any = 0;

    public formServicios: FormGroup;
    public formServiciosBucket: FormGroup;
    public closeResult: string;

    currentPage: number = 1;
    pageSize: number = 10; // Tamaño de página inicial
    totalItems: number = 0;
    spinner: boolean;
    toast = Swal;
    isEditMode = false;
    formServiciosIsSubmited = false;
    formServiciosBucketIsSubmited = false;
    idServicio: string = '';
    estadoServicioExterno: boolean = false;
    nombreCortoServicio: string = '';
    nombreArchivo: string = '';
    public maxFile = 1;
    public maxFileSize = 10;
    public multiple = false;
    archivo: boolean = false;
    codigo = '';
    respuestaConexion: any;
    mostrarDetalle: boolean = false;
    baseUrl: string = '';
    tiempoConexion: number = 0;

    firmaGuardada: boolean = false;
    ocultarFirmaGuardada: boolean = false;
    accesUser: boolean = false;

    jsonValido = false;

    tableHeaders = [
        { key: 'nombre', label: 'Nombre' },
        { key: 'nombre_corto', label: 'Nombre corto' },
        { key: 'authUsername', label: 'User name' },
        { key: 'createdAt', label: 'Fecha de Creación' },
        { key: 'updatedAt', label: 'Fecha de Actualización' },
    ];

    editorOptions = {
        theme: 'vs-dark',
        language: 'javascript',
        automaticLayout: true,
        minimap: {
            enabled: true
        }
    };

    // Definición de las acciones personalizadas
    customActions: TableAction[] = [];

    @ViewChild('modalAgregarServicio') referenServicioModal!: TemplateRef<any>;
    @ViewChild('modalSubirArchivo') subirArchivoModal!: TemplateRef<any>;
    @ViewChild('modalResultadoConexion') ResultadoConexionModal!: TemplateRef<any>;
    @ViewChild('modalBucketServicio') modalBucketServicio!: TemplateRef<any>;
    @ViewChild('fileUpload', { static: false }) fileUploadComponent?: FileUploadComponent;


    constructor(
        private seriviciosServices: ServiciosService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        private integracionServices: IntegracionServices,
        private route: ActivatedRoute,
        private router: Router , 
        private authService: AuthService
    ) { }

    async ngOnInit() {
        this.accesUser = this.authService.hasRoleAuth('ADMINISTRADOR');

        this.toastAlert();
        this.initUserForm();
        this.getServicios();

        this.customActions = [
            {
                label: 'Editar',
                handler: (item: ServicioModel) => this.showServicio(item.id),
                icon: 'fa-solid fa-pen-to-square',
                colorClass: 'bg-orange'
            },
            {
                label: 'Configuración de servicio',
                handler: (item: ServicioModel) => this.irConfiguracionServicios(item.id),
                icon: 'fa-solid fa-gears',
                colorClass: 'bg-blue'
            },
            {
                label: 'Gestionar Acceso',
                handler: (item: Item) => {
                                     
                    return this.gestionarAcceso(item.id);
                },
                icon: 'fa-solid fa-lock',
                colorClass: 'bg-blue',
                visible: (item: Item) => {
                    return item && this.authService.canManageItem(item, this.accesUser);
                }
            }
            // {
            //     label: 'Subir archivo',
            //     handler: (item: ServicioModel) => this.openArchivo(item.id),
            //     icon: 'fa-solid fa-upload',
            //     colorClass: 'bg-green'
            // },
            // {
            //     label: 'Conexion Bucket',
            //     handler: (item: ServicioModel) => this.openBucket(item),
            //     icon: 'fa-solid fa-box-archive',
            //     colorClass: 'bg-blue'
            // },
        ];
    }

    ngAfterViewInit(): void {



    }

    
    async gestionarAcceso(id: any) {
        const modalRef = this.modalService.open(PermisosModalComponent, {
            centered: true,
            size: 'xl',
        });
        modalRef.componentInstance.id = id;
        modalRef.componentInstance.modeloAcceso = 'ServicioExterno';
    }
    

    async getServicios() {
        this.spinner = true;
        let params = new HttpParams();
        params = params.set('page', this.currentPage).set('limit', this.pageSize).set('pagination', true);
        const result = await lastValueFrom(
            this.seriviciosServices.getServicios(params)
        );

        const headers: HttpHeaders = result.headers;
        this.currentItems = result.body as ServicioModel[];

        this.currentItems = (result.body ?? []).map((x: ServicioModel) => ({
            ...x,
            createdAt: x.createdAt ? this.formatFechaLocalSinUTC(x.createdAt) : '',
            updatedAt: x.updatedAt ? this.formatFechaLocalSinUTC(x.updatedAt) : ''
        }));
        this.totalItems = Number(headers.get('X-Total-Count'));
        this.spinner = false;
    }

    async crearServicio() {
        this.formServiciosIsSubmited = true;
        if (!this.formServicios.valid) {
            this.formServicios.markAllAsTouched();
            return false;
        }
        const response = await lastValueFrom(this.seriviciosServices.crearServicio(this.formServicios.value));
        this.alert('success', 'Éxito!', 'Servicio Registrado!');
        this.getServicios();
        this.modalService.dismissAll();
        this.formServiciosIsSubmited = false;
    }

    async editarServicio() {
        this.formServiciosIsSubmited = true;
        if (!this.formServicios.valid) {
            this.formServicios.markAllAsTouched();
            return false;
        }

        const datos = { ...this.formServicios.value };
        delete datos.nombre_corto;
        if (this.firmaGuardada) {
            delete datos.auth_password;
        }

        const response = await lastValueFrom(this.seriviciosServices.editarServicio(datos, this.idServicio));
        this.alert('success', 'Éxito!', 'Servicio Registrado!');
        this.getServicios();
        this.modalService.dismissAll();
        this.formServiciosIsSubmited = false;
    }

    irConfiguracionServicios(id: string): void {
        this.router.navigate(['integraciones/configuracion/servicios-externos/'+id]);
    }

    async crearServicioBucket() {
        this.formServiciosBucketIsSubmited = true;
        if (!this.formServiciosBucket.valid) {
            this.formServiciosBucket.markAllAsTouched();
            return false;
        }
        const response = await lastValueFrom(this.seriviciosServices.crearConfigBucket(this.formServiciosBucket.value, this.idServicio));
        this.alert('success', 'Éxito!', 'Servicio Registrado!');
        this.getServicios();
        this.modalService.dismissAll();
        this.formServiciosBucketIsSubmited = false;
    }

    async editarServicioBucket() {
        this.formServiciosBucketIsSubmited = true;
        if (!this.formServiciosBucket.valid) {
            this.formServiciosBucket.markAllAsTouched();
            return false;
        }

        const datos = { ...this.formServicios.value };
        delete datos.nombre_corto;
        if (this.firmaGuardada) {
            delete datos.auth_password;
        }

        const response = await lastValueFrom(this.seriviciosServices.editarServicio(datos, this.idServicio));
        this.alert('success', 'Éxito!', 'Servicio Registrado!');
        this.getServicios();
        this.modalService.dismissAll();
        this.formServiciosBucketIsSubmited = false;
    }

    async openArchivo(id: string) {
        this.idServicio = id;
        this.fileUploadComponent?.clearFiles();
        this.showArchivo();
        this.estadoServicio();
        this.openModalContent(this.subirArchivoModal, false);
    }

    async openBucket(item: any) {
        // this.idServicio = id;
        // this.fileUploadComponent?.clearFiles();
        
        // this.estadoServicio();
        // this.openModalContent(this.modalBucketServicio, false);
    }

    async showBucket(item: any) {
        
        // this.idServicio = id;
        // const response = await lastValueFrom(this.seriviciosServices.showBucket(id));
        // const servicioBucket = response.body;


        // if (!servicioBucket) return;
        // this.openModalContent(this.referenServicioModal, true);
        // this.onChangeFirmaGuardada();
        // this.formServicios.patchValue({
        //     nombre: servicio.nombre,
        //     nombre_corto: servicio.nombre_corto,
        //     auth_url: servicio.authUrl,
        //     base_url: servicio.baseUrl,
        //     auth_username: servicio.authUsername,
        // });
    }

    async showServicio(id: string) {
        this.idServicio = id;
        this.ocultarFirmaGuardada = true;
        this.firmaGuardada = true;
        const response = await lastValueFrom(this.seriviciosServices.showServicios(id));
        const servicio = response.body;

        if (!servicio) return;
        this.openModalContent(this.referenServicioModal, true);
        this.onChangeFirmaGuardada();
        this.formServicios.patchValue({
            nombre: servicio.nombre,
            nombre_corto: servicio.nombre_corto,
            auth_url: servicio.authUrl,
            base_url: servicio.baseUrl,
            auth_username: servicio.authUsername,
        });
    }

    async showArchivo() {
        const response = await lastValueFrom(this.seriviciosServices.showArchivo(this.idServicio));
        let url = response?.body?.url_documento;
        this.selectedFiles = [];
        if (url != null) {

            this.archivo = true;
            const contenido = this.base64ToString(url);
            this.codigo = contenido;
        } else {

            this.codigo = '';
            this.archivo = false;
        }

    }

    base64ToString(base64: string): string {
        const bytes = Uint8Array.from(
            atob(base64),
            c => c.charCodeAt(0)
        );

        return new TextDecoder('utf-8').decode(bytes);
    }

    guardarServicio() {
        if (this.isEditMode) {
            this.editarServicio();
        } else {
            this.crearServicio();
        }
    }

    guardarServicioBucket() {
        if (this.isEditMode) {
            this.editarServicioBucket();
        } else {
            this.crearServicioBucket();
        }
    }

    async cambioEstado(estado: string, id: string) {

        const body = {
            "nombre_corto": estado
        }
        const response = await lastValueFrom(this.seriviciosServices.estadoServicio(body, id));
    }

    initUserForm(): void {
        this.formServicios = this.fb.group({
            nombre: ['', [Validators.required, Validators.minLength(3)]],
            nombre_corto: ['', [Validators.required, Validators.minLength(3)]],
            auth_url: ['', [Validators.required, Validators.minLength(3)]],
            base_url: ['', [Validators.required]], // Ejemplo de longitud mínima
            auth_username: ['', [Validators.required]],
            auth_password: ['', [Validators.required]]
        });

        this.formServiciosBucket = this.fb.group({
            proveedor: ['', [Validators.required, Validators.minLength(3)]],
            region: ['', [Validators.required, Validators.minLength(3)]],
            bucketOContenedor: ['', [Validators.required, Validators.minLength(3)]],
            credencialesJson: ['', [Validators.required]]
        });


    }

    handleFiles(file: File) {

        this.selectedFiles = file;

    }

    async subirDocumentos(): Promise<boolean> {

        if (this.codigo) {
            this.selectedFiles = new File(
                [this.codigo],
                'config.js', // Ej: config.js
                {
                    type: 'text/javascript'
                }
            );
        }
        let files: File[] =
            this.selectedFiles instanceof File
                ? [this.selectedFiles]
                : Array.isArray(this.selectedFiles)
                    ? this.selectedFiles
                    : this.selectedFiles
                        ? Array.from(this.selectedFiles as FileList)
                        : [];

        // 1️⃣ Si hay archivos → SIEMPRE subir
        if (files.length > 0) {

            try {
                const formData = new FormData();
                files.forEach(f => formData.append('file', f, f.name));
                await lastValueFrom(
                    this.seriviciosServices.addArchivo(this.idServicio, formData)
                );
                this.alert('success', 'Documento cargado correctamente');
                this.fileUploadComponent?.clearFiles();
                this.selectedFiles = [];
                if (!this.estadoServicioExterno) {
                    this.cambioEstado('PPC', this.idServicio);
                }

                if (!this.codigo) {
                    this.modalService.dismissAll();
                }


            } catch (error) {
                console.error(error);
                this.alert('error', 'Error al subir documentos');
                return false;
            }
        } else {
            this.alert('warning', 'Coloca un archivo js para realizar la configuración.');
        }


        return true;
    }

    async pruebaConexion() {

        const { resultado, tiempo } = await this.medirTiempo(async () => {
            return await lastValueFrom(
                this.integracionServices.pruebaConexion(this.nombreCortoServicio)
            );
        });

        this.tiempoConexion = tiempo;
        this.mostrarDetalle = false;
        if (resultado) {
            this.respuestaConexion = resultado;
            this.openModalContent(this.ResultadoConexionModal, false, 'lg', 'modal-conexion');
        }

    }

    async medirTiempo<T>(callback: () => Promise<T>): Promise<{ resultado: T; tiempo: number }> {
        const inicio = performance.now();

        const resultado = await callback();

        const tiempo = Math.round(performance.now() - inicio);

        return {
            resultado,
            tiempo
        };
    }

    async estadoServicio() {
        const response = await lastValueFrom(this.seriviciosServices.showServicios(this.idServicio));
        const servicio = response.body;
        this.estadoServicioExterno = servicio?.id_estado != 11 ? false : true;
        this.nombreCortoServicio = servicio?.nombre_corto ?? '';
        this.baseUrl = servicio?.baseUrl ?? '';
        this.nombreArchivo = this.nombreCortoServicio ? this.nombreCortoServicio.toLowerCase() + '.config.js' : '';
    }

    openModalContent(
        content: any,
        mode: boolean,
        size: 'sm' | 'lg' | 'xl' = 'lg',
        windowClass?: string
    ) {
        this.formServicios.reset();
        this.formServiciosBucket.reset();
        this.isEditMode = mode;

        this.modalService.open(content, {
            ariaLabelledBy: 'modal-basic-title',
            size,
            centered: true,
            windowClass
        }).result.then(
            (result) => {
                this.closeResult = `Closed with: ${result}`;
            },
            (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }


    onPageChange(newPage: number): void {
        this.currentPage = newPage;
        // this.getPlantilas();
    }

    formatFechaLocalSinUTC(iso: string): string {

        if (!iso) {
            return '';
        }
        // Quitamos la Z y los milisegundos
        const limpia = iso.replace('Z', '').split('.')[0];

        const d = new Date(limpia);

        const pad = (n: number) => n.toString().padStart(2, '0');

        return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} `
            + `${pad(d.getHours())}:${pad(d.getMinutes())}`;
    }

    onChangeFirmaGuardada() {

        const passwordControl = this.formServicios.get('auth_password');

        if (this.firmaGuardada) {
            passwordControl?.clearValidators();
            passwordControl?.setValue('******************');

        } else {
            passwordControl?.setValidators([
                Validators.required
            ]);
            passwordControl?.setValue('');

        }

        passwordControl?.updateValueAndValidity();
    }

    toggleDetalle(): void {
        this.mostrarDetalle = !this.mostrarDetalle;
    }

    //  INICIO METODOS PARA EL BUCKET

    formatJsonOnPaste(): void {
        setTimeout(() => {
            this.formatJson();
        });
    }

    formatJson(): void {
        const control = this.formServiciosBucket.get('credencialesJson');
        const value = control?.value;

        if (!value) {
            this.jsonValido = false;
            return;
        }

        try {
            const json = JSON.parse(value);

            control?.setValue(
                JSON.stringify(json, null, 2),
                { emitEvent: false }
            );

            this.jsonValido = true;

        } catch {
            this.jsonValido = false;
        }
    }

    copyJson(): void {
        const value = this.formServiciosBucket.get('credencialesJson')?.value;

        if (!value) {
            return;
        }

        navigator.clipboard.writeText(value);
    }

    //  FIN METODOS PARA EL BUCKET

    onPageSizeChange(newSize: number): void {
        this.pageSize = newSize;
        this.currentPage = 1; // Siempre vuelve a la primera página al cambiar el tamaño
        // this.getPlantilas();
    }

    toastAlert() {
        this.toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            }
        });
    }

    alert(icontext: SweetAlertIcon, title: string, text: string = '') {
        this.toast.fire({
            icon: icontext,
            title: title,
            text: text
        });
    }


}